<template>

	<form
		class="PressKit-form"
		ref="contactForm"
		@submit="handleSubmit">

		<h4 class="heading">
			Contact Stitch Fix
		</h4>

		<p v-if="(!feedbackVisible || isError)">
			{{ greeting }}
		</p>

		<div
			:class="{
            'error-message' : isError,
            'feedback-message' : !isError,
          }"
			v-show="feedbackVisible"
			v-html="feedbackMessage"></div>

		<fieldset v-if="(!feedbackVisible || isError)">
			<label for="name">Name</label>
			<input type="text" name="name" id="name" required="" v-model="name">

			<label for="email">Email</label>
			<input
				type="email"
				name="email"
				id="email"
				required=""
				:class="{ email }"
				v-model="email">

<!--			<div class="message-wrapper">-->
<!--				<label for="textarea">Message</label>-->
<!--				<textarea-->
<!--					class="message"-->
<!--					name="textarea"-->
<!--					id="textarea"-->
<!--					required=""-->
<!--					v-model="message">-->
<!--				</textarea>-->
<!--			</div>-->
			<div id="recaptcha"></div>
			<input type="submit" name="submit" id="submit" value="Submit Request">

		</fieldset>

	</form>

</template>


<script>
import validation from "../mixins/form-validation.vue";

export default {

	name: 'contact-form',

	mixins: [
		validation
	],

	components: {},

	props: {

		greeting: {
			default: 'Thank you for your interest in our press kit. Complete the form below and we will be in touch.',
			type: String,
		},

		button_text: {
			default: 'Submit',
			type: String,
		},

	},

	data: function() {
		return {
			feedbackVisible: false,
			feedbackMessage: '',
			isError: false,
			name: "",
			email: "",
			message: "",
		};
	},

	methods: {

		handleSubmit( event ) {
			event.preventDefault()
			this.feedbackVisible = false
			this.isError = false;

			if(!grecaptcha.getResponse()) {
				this.feedbackMessage = 'Please complete reCAPTCHA'
				this.feedbackVisible = true
				this.isError = true
			}

			if ( !this.form__validEmail(this.email) ) {
				this.feedbackMessage = 'Please enter a valid email address.'
				this.feedbackVisible = true
				this.isError = true
			}

			if(!this.isError){

				axios({
					method: 'GET',
					url: window.location.protocol + '//' + window.location.hostname + '/wp-json/sfnews/contact',
					headers: {
						'Cache-Control': 'no-cache',
					},
					params: {
						name: this.name,
						email: this.email,
						recaptcha: grecaptcha.getResponse(),
						// message: this.message
					},
					validateStatus: (status) => {
						return (parseInt(status) === 200)
					}
				})
				.then((response) => {
					if( 200 === response.data.status ) {
						this.name = ''
						this.email = ''
						this.message = ''
						this.feedbackMessage = 'Thank you, we will be in touch soon.'
						this.feedbackVisible = true
						this.isError = false
					}
				})
				.catch((error) => {
					this.feedbackMessage = 'There was an error processing your request. Please try again.'
					this.feedbackVisible = true
					this.isError = true
					console.warn(error)
				})
			}

		},

		renderCaptcha() {
			grecaptcha.render('recaptcha', {
				sitekey: '6Ld5xdwbAAAAANH7EyMMp3TwaCvX8Ql3LbDwuT86',
			})
		}

	},

	mounted() {
		this.renderCaptcha()
	}

}
</script>
